<template>
  <div class="">
    <div class="w-full lg:mt-20 md:mt-20 mt-16 mb-8">
      <CareProffessionBanner />
    </div>
    <div>
      <ProfessionalsForm />
    </div>

    <div class="lg:px-40 md:px-40 px-5 lg:mt-12 md:mt-12 mt-6">
      <ProfessionalContent />
    </div>

    <div class="bge3ceff-opa rounded-t-5555">
      <DownloadApp />
      <Footer />
    </div>
  </div>
</template>

<script>
import Footer from "../Footer.vue";
import DownloadApp from "@/views/home/components/DownloadApp.vue";
import CareProffessionBanner from "./components/CareProffessionBanner.vue";
import ProfessionalsForm from "./components/ProfessionalsForm.vue";
import ProfessionalContent from "./components/ProfessionalContent.vue";
export default {
  components: {
    CareProffessionBanner,
    ProfessionalsForm,
    ProfessionalContent,
    Footer,
    DownloadApp,
  },
};
</script>

<style></style>
